import { buildCutListCsvHeaderDescriptors } from "../messages/exportMessages.js";
import { resolveExportRow } from "./orderOversize";
import { getWerkplanPlateNumbers, filterWerkplanRows } from "./werkplanExport";

export function escapeCsvField(value) {
  const text = String(value ?? "");
  if (/[;"\n\r]/.test(text)) {
    return `"${text.replace(/"/g, '""')}"`;
  }
  return text;
}

/**
 * @param {object[]} rows
 * @param {object} layout
 * @param {object|null} exportDraft
 * @param {object|null} sourcePanel
 * @param {{ resolveMessage?: (descriptor: object) => string }} [options]
 */
export function buildCutListCsv(rows, layout, exportDraft = null, sourcePanel = null, options = {}) {
  const resolveMessage = options.resolveMessage || ((value) => (
    typeof value === "string" ? value : String(value?.literal ?? value?.key ?? "")
  ));
  const werkplanScope = {
    includeNewSheets: exportDraft?.includeNewSheets !== false,
    includeRestSheets: exportDraft?.includeRestSheets !== false,
  };
  const exportRows = filterWerkplanRows(rows, layout, werkplanScope);
  const resolveOptions = {
    layout,
    sourcePanel,
    scope: werkplanScope,
  };
  const header = buildCutListCsvHeaderDescriptors().map((descriptor) => resolveMessage(descriptor));

  const lines = exportRows.map((row) => {
    const override = exportDraft?.rowOverrides?.[row.id] || {};
    const resolved = exportDraft
      ? resolveExportRow(row, exportDraft, override, resolveOptions)
      : row;
    const instruction = override?.instructionEdited && override?.instruction
      ? override.instruction
      : resolveMessage(row.instruction);

    return [
      row.quantity,
      resolved.orderLength,
      resolved.orderWidth,
      row.finalLength,
      row.finalWidth,
      row.thickness,
      resolveMessage(row.name),
      row.projectName,
      row.materialName,
      resolveMessage(row.edges),
      getWerkplanPlateNumbers(layout, row.id, werkplanScope),
      instruction,
    ].map(escapeCsvField).join(";");
  });

  return `\uFEFF${[header.join(";"), ...lines].join("\n")}`;
}
